<template>
  <div>
    <h3>
      {{ t('deliveryRoute') }}
    </h3>
    <ul class="delivery-route mt-3">
      <li
        v-for="(event, index) in eventsForDisplay"
        :key="`event-id-${event.id}`"
        :class="{ 'last-child': index === 2 && !showEventsMore }"
      >
        <EventRouteBlock :event="event" />
      </li>
    </ul>
    <b-button
      v-if="events.length > limit"
      variant="link"
      class="p-0 expand-list"
      :class="{ active: showEventsMore }"
      @click="toggleShowMoreEvent"
    >
      {{ moreEventsBtnText }}
      <ExpandIcon />
    </b-button>
    <hr class="tracking-divider" />
  </div>
</template>

<script lang="ts">
import type { TrackingEvent } from '@/types/Models/Shipment'
import { defineComponent, ref, computed, type Ref, type ComputedRef, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import ExpandIcon from '@/views/Elements/Icons/ExpandIcon.vue'
import EventRouteBlock from '@/views/Components/EventRouteBlock.vue'

export default defineComponent({
  name: 'TrackingEvents',
  components: {
    EventRouteBlock,
    ExpandIcon,
  },
  props: {
    events: {
      type: Array as PropType<TrackingEvent[]>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const showEventsMore: Ref<boolean> = ref(false)
    const limit = 3

    const moreEventsBtnText: ComputedRef<string> = computed(() => {
      return showEventsMore.value ? t('viewLess') : t('viewMore')
    })

    const eventsForDisplay: ComputedRef<TrackingEvent[]> = computed(() => {
      return showEventsMore.value ? props.events : props.events.slice(0, limit)
    })

    const toggleShowMoreEvent = () => {
      showEventsMore.value = !showEventsMore.value
    }

    return {
      limit,
      showEventsMore,
      moreEventsBtnText,
      eventsForDisplay,
      toggleShowMoreEvent,
      t,
    }
  },
})
</script>
